import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { 
  LayoutDashboard, 
  Users, 
  FileText, 
  BarChart3,
  MoreHorizontal
} from 'lucide-react';

export const BottomNav = ({ onMenuClick }) => {
  const location = useLocation();
  const { t } = useLanguage();
  
  const navItems = [
    { path: '/dashboard', icon: LayoutDashboard, label: 'dashboard' },
    { path: '/clients', icon: Users, label: 'clients' },
    { path: '/invoices', icon: FileText, label: 'invoices' },
    { path: '/reports', icon: BarChart3, label: 'reports' },
  ];

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 z-50 shadow-lg">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 h-full py-2 transition-all ${
                isActive 
                  ? 'text-primary' 
                  : 'text-slate-400 hover:text-slate-600'
              }`}
              data-testid={`bottom-nav-${item.label}`}
            >
              <div className={`p-1.5 rounded-lg transition-colors ${isActive ? 'bg-primary/10' : ''}`}>
                <item.icon size={20} strokeWidth={isActive ? 2.5 : 2} />
              </div>
              <span className={`text-[10px] mt-0.5 font-cairo ${isActive ? 'font-bold' : 'font-medium'}`}>
                {t(item.label)}
              </span>
            </Link>
          );
        })}
        <button
          onClick={onMenuClick}
          className="flex flex-col items-center justify-center flex-1 h-full py-2 text-slate-400 hover:text-slate-600 transition-all"
          data-testid="bottom-nav-menu"
        >
          <div className="p-1.5">
            <MoreHorizontal size={20} />
          </div>
          <span className="text-[10px] mt-0.5 font-cairo font-medium">{t('more')}</span>
        </button>
      </div>
    </nav>
  );
};

export default BottomNav;
